import type { TOC } from '@ember/component/template-only'
import FlashMessage from 'ember-cli-flash/components/flash-message'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { eq, or } from 'ember-truth-helpers'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import type { CustomFlashMessageObject } from 'teacher-ui-client/services/flash-queue'

interface Args {
  flash: CustomFlashMessageObject
}

interface Signature {
  Args: Args
  Element: Element
}

export const FlashBox: TOC<Signature> = <template>
  {{#let (or @flash.flashType "default") as |flashType|}}
    {{! Note: some styles provided in _flash.css file }}
    <FlashMessage
      data-test-flash-box={{flashType}}
      class="flash-box-animate-in-out border-y-neutral-75 border-r-neutral-75 pointer-events-auto flex w-lg translate-x-full gap-4 overflow-hidden rounded-lg border-y border-r border-l-4 bg-white p-4 text-neutral-300 shadow-md transition-transform duration-500
        {{if (eq flashType 'default') 'border-l-dusty-black-100'}}
        {{if (eq flashType 'positive') 'border-l-green-300'}}
        {{if (eq flashType 'critical') 'border-l-red-300'}}
        {{if (eq flashType 'caution') 'border-l-juicy-orange-300'}}
        {{if (eq flashType 'info') 'border-l-blue-325'}}
        {{if @flash.destroyOnClick 'cursor-pointer'}}"
      ...attributes
      @flash={{@flash}}
      as |_flash_message _flash_object closeAction|
    >
      {{! Icon }}
      {{#if @flash.icon}}
        <PhosphorIcon
          data-test-flash-box-icon={{@flash.icon}}
          @icon={{@flash.icon}}
          class="h-6 w-6 shrink-0
            {{if (eq flashType 'default') 'text-black'}}
            {{if (eq flashType 'positive') 'text-green-300'}}
            {{if (eq flashType 'critical') 'text-red-300'}}
            {{if (eq flashType 'caution') 'text-juicy-orange-400'}}
            {{if (eq flashType 'info') 'text-blue-325'}}"
        />
      {{/if}}
      {{! Content }}
      <div class="grow space-y-2">
        {{#if @flash.title}}
          <div data-test-flash-box-title class="text-sm font-medium text-neutral-400">{{@flash.title}}</div>
        {{/if}}
        {{#if @flash.subtitle}}
          <div data-test-flash-box-subtitle class="text-sm">
            {{@flash.subtitle}}
          </div>
        {{/if}}
      </div>

      {{! Action }}
      {{#if @flash.showClose}}
        <div class="ml-auto">
          <button type="button" aria-label={{t "close"}} {{on "click" closeAction}} data-test-flash-box-close>
            <PhosphorIcon class="h-4 w-4" @icon="phosphor-x-bold" />
          </button>
        </div>
      {{/if}}

    </FlashMessage>
  {{/let}}
</template>

export default FlashBox
